/**
 * True only in the embeddable web-component build (`vite.embed.config.ts` sets
 * `import.meta.env.VITE_EMBED`). Undefined in the SPA build, so embed-only
 * branches are dead-code-eliminated from `book.dorsia.com` and the SPA is
 * provably unaffected.
 */
export const IS_EMBED = (import.meta.env as Record<string, string | undefined>).VITE_EMBED === 'true';
